// import countryData from '@/assets/countryData.json';
export type Code = {
  id: number;
  name: string;
};

export type AreaCode = Code[];

const areaCode: AreaCode = [
  {
    "id": 1,
    "name": "+86"
  },
  {
    "id": 2,
    "name": "+852"
  },
  {
    "id": 3,
    "name": "+886"
  },
  {
    "id": 4,
    "name": "+93"
  },
  {
    "id": 38,
    "name": "+1"
  },
  {
    "id": 5,
    "name": "+355"
  },
  {
    "id": 6,
    "name": "+213"
  },
  {
    "id": 7,
    "name": "+1684"
  },
  {
    "id": 8,
    "name": "+376"
  },
  {
    "id": 9,
    "name": "+244"
  },
  {
    "id": 10,
    "name": "+1264"
  },
  {
    "id": 11,
    "name": "+1268"
  },
  {
    "id": 12,
    "name": "+54"
  },
  {
    "id": 13,
    "name": "+374"
  },
  {
    "id": 14,
    "name": "+297"
  },
  {
    "id": 15,
    "name": "+61"
  },
  {
    "id": 16,
    "name": "+43"
  },
  {
    "id": 17,
    "name": "+994"
  },
  {
    "id": 18,
    "name": "+973"
  },
  {
    "id": 19,
    "name": "+880"
  },
  {
    "id": 20,
    "name": "+1246"
  },
  {
    "id": 21,
    "name": "+375"
  },
  {
    "id": 22,
    "name": "+32"
  },
  {
    "id": 23,
    "name": "+501"
  },
  {
    "id": 24,
    "name": "+229"
  },
  {
    "id": 25,
    "name": "+1441"
  },
  {
    "id": 26,
    "name": "+975"
  },
  {
    "id": 27,
    "name": "+591"
  },
  {
    "id": 28,
    "name": "+387"
  },
  {
    "id": 29,
    "name": "+267"
  },
  {
    "id": 30,
    "name": "+55"
  },
  {
    "id": 31,
    "name": "+246"
  },
  {
    "id": 32,
    "name": "+673"
  },
  {
    "id": 33,
    "name": "+359"
  },
  {
    "id": 34,
    "name": "+226"
  },
  {
    "id": 35,
    "name": "+257"
  },
  {
    "id": 36,
    "name": "+855"
  },
  {
    "id": 37,
    "name": "+237"
  },

  {
    "id": 39,
    "name": "+238"
  },
  {
    "id": 40,
    "name": "+1345"
  },
  {
    "id": 41,
    "name": "+236"
  },
  {
    "id": 42,
    "name": "+235"
  },
  {
    "id": 43,
    "name": "+682"
  },
  {
    "id": 44,
    "name": "+506"
  },
  {
    "id": 45,
    "name": "+225"
  },
  {
    "id": 46,
    "name": "+385"
  },
  {
    "id": 47,
    "name": "+53"
  },
  {
    "id": 48,
    "name": "+599"
  },
  {
    "id": 49,
    "name": "+357"
  },
  {
    "id": 50,
    "name": "+420"
  },
  {
    "id": 51,
    "name": "+45"
  },
  {
    "id": 52,
    "name": "+253"
  },
  {
    "id": 53,
    "name": "+1767"
  },
  {
    "id": 54,
    "name": "+1"
  },
  {
    "id": 55,
    "name": "+593"
  },
  {
    "id": 56,
    "name": "+20"
  },
  {
    "id": 57,
    "name": "+503"
  },
  {
    "id": 58,
    "name": "+240"
  },
  {
    "id": 59,
    "name": "+291"
  },
  {
    "id": 60,
    "name": "+372"
  },
  {
    "id": 61,
    "name": "+251"
  },
  {
    "id": 62,
    "name": "+500"
  },
  {
    "id": 63,
    "name": "+298"
  },
  {
    "id": 64,
    "name": "+679"
  },
  {
    "id": 65,
    "name": "+358"
  },
  {
    "id": 66,
    "name": "+33"
  },
  {
    "id": 67,
    "name": "+594"
  },
  {
    "id": 68,
    "name": "+689"
  },
  {
    "id": 69,
    "name": "+241"
  },
  {
    "id": 70,
    "name": "+995"
  },
  {
    "id": 71,
    "name": "+49"
  },
  {
    "id": 72,
    "name": "+233"
  },
  {
    "id": 73,
    "name": "+350"
  },
  {
    "id": 74,
    "name": "+30"
  },
  {
    "id": 75,
    "name": "+299"
  },
  {
    "id": 76,
    "name": "+1473"
  },
  {
    "id": 77,
    "name": "+590"
  },
  {
    "id": 78,
    "name": "+1671"
  },
  {
    "id": 79,
    "name": "+502"
  },
  {
    "id": 80,
    "name": "+1481"
  },
  {
    "id": 81,
    "name": "+224"
  },
  {
    "id": 82,
    "name": "+245"
  },
  {
    "id": 83,
    "name": "+592"
  },
  {
    "id": 84,
    "name": "+509"
  },
  {
    "id": 85,
    "name": "+504"
  },
  {
    "id": 86,
    "name": "+36"
  },
  {
    "id": 87,
    "name": "+354"
  },
  {
    "id": 88,
    "name": "+91"
  },
  {
    "id": 89,
    "name": "+62"
  },
  {
    "id": 90,
    "name": "+98"
  },
  {
    "id": 91,
    "name": "+964"
  },
  {
    "id": 92,
    "name": "+353"
  },
  {
    "id": 93,
    "name": "+972"
  },
  {
    "id": 94,
    "name": "+39"
  },
  {
    "id": 95,
    "name": "+1876"
  },
  {
    "id": 96,
    "name": "+81"
  },
  {
    "id": 97,
    "name": "+962"
  },
  {
    "id": 98,
    "name": "+7"
  },
  {
    "id": 99,
    "name": "+965"
  },
  {
    "id": 100,
    "name": "+996"
  },
  {
    "id": 101,
    "name": "+856"
  },
  {
    "id": 102,
    "name": "+371"
  },
  {
    "id": 103,
    "name": "+261"
  },
  {
    "id": 104,
    "name": "+265"
  },
  {
    "id": 105,
    "name": "+60"
  },
  {
    "id": 106,
    "name": "+960"
  },
  {
    "id": 107,
    "name": "+223"
  },
  {
    "id": 108,
    "name": "+356"
  },
  {
    "id": 109,
    "name": "+692"
  },
  {
    "id": 110,
    "name": "+596"
  },
  {
    "id": 111,
    "name": "+222"
  },
  {
    "id": 112,
    "name": "+230"
  },
  {
    "id": 113,
    "name": "+262"
  },
  {
    "id": 114,
    "name": "+52"
  },
  {
    "id": 115,
    "name": "+691"
  },
  {
    "id": 116,
    "name": "+373"
  },
  {
    "id": 117,
    "name": "+377"
  },
  {
    "id": 118,
    "name": "+976"
  },
  {
    "id": 119,
    "name": "+382"
  },
  {
    "id": 120,
    "name": "+1664"
  },
  {
    "id": 121,
    "name": "+212"
  },
  {
    "id": 122,
    "name": "+258"
  },
  {
    "id": 123,
    "name": "+95"
  },
  {
    "id": 124,
    "name": "+264"
  },
  {
    "id": 125,
    "name": "+674"
  },
  {
    "id": 126,
    "name": "+977"
  },
  {
    "id": 127,
    "name": "+31"
  },
  {
    "id": 128,
    "name": "+687"
  },
  {
    "id": 129,
    "name": "+64"
  },
  {
    "id": 130,
    "name": "+505"
  },
  {
    "id": 131,
    "name": "+227"
  },
  {
    "id": 132,
    "name": "+234"
  },
  {
    "id": 133,
    "name": "+683"
  },
  {
    "id": 134,
    "name": "+672"
  },
  {
    "id": 135,
    "name": "+850"
  },
  {
    "id": 136,
    "name": "+1670"
  },
  {
    "id": 137,
    "name": "+47"
  },
  {
    "id": 138,
    "name": "+968"
  },
  {
    "id": 139,
    "name": "+92"
  },
  {
    "id": 140,
    "name": "+680"
  },
  {
    "id": 141,
    "name": "+970"
  },
  {
    "id": 142,
    "name": "+507"
  },
  {
    "id": 143,
    "name": "+675"
  },
  {
    "id": 144,
    "name": "+595"
  },
  {
    "id": 145,
    "name": "+51"
  },
  {
    "id": 146,
    "name": "+63"
  },
  {
    "id": 147,
    "name": "+48"
  },
  {
    "id": 148,
    "name": "+351"
  },
  {
    "id": 149,
    "name": "+1"
  },
  {
    "id": 150,
    "name": "+974"
  },
  {
    "id": 151,
    "name": "+262"
  },
  {
    "id": 152,
    "name": "+40"
  },
  {
    "id": 153,
    "name": "+7"
  },
  {
    "id": 154,
    "name": "+250"
  },
  {
    "id": 155,
    "name": "+290"
  },
  {
    "id": 156,
    "name": "+1869"
  },
  {
    "id": 157,
    "name": "+1758"
  },
  {
    "id": 158,
    "name": "+590"
  },
  {
    "id": 159,
    "name": "+508"
  },
  {
    "id": 160,
    "name": "+1784"
  },
  {
    "id": 161,
    "name": "+685"
  },
  {
    "id": 162,
    "name": "+378"
  },
  {
    "id": 163,
    "name": "+239"
  },
  {
    "id": 164,
    "name": "+966"
  },
  {
    "id": 165,
    "name": "+221"
  },
  {
    "id": 166,
    "name": "+381"
  },
  {
    "id": 167,
    "name": "+248"
  },
  {
    "id": 168,
    "name": "+232"
  },
  {
    "id": 169,
    "name": "+65"
  },
  {
    "id": 170,
    "name": "+1721"
  },
  {
    "id": 171,
    "name": "+421"
  },
  {
    "id": 172,
    "name": "+386"
  },
  {
    "id": 173,
    "name": "+677"
  },
  {
    "id": 174,
    "name": "+268"
  },
  {
    "id": 175,
    "name": "+252"
  },
  {
    "id": 176,
    "name": "+27"
  },
  {
    "id": 177,
    "name": "+82"
  },
  {
    "id": 178,
    "name": "+211"
  },
  {
    "id": 179,
    "name": "+34"
  },
  {
    "id": 180,
    "name": "+94"
  },
  {
    "id": 181,
    "name": "+249"
  },
  {
    "id": 182,
    "name": "+597"
  },
  {
    "id": 183,
    "name": "+268"
  },
  {
    "id": 184,
    "name": "+255"
  },
  {
    "id": 185,
    "name": "+66"
  },
  {
    "id": 186,
    "name": "+1242"
  },
  {
    "id": 187,
    "name": "+220"
  },
  {
    "id": 188,
    "name": "+670"
  },
  {
    "id": 189,
    "name": "+228"
  },
  {
    "id": 190,
    "name": "+690"
  },
  {
    "id": 191,
    "name": "+676"
  },
  {
    "id": 192,
    "name": "+1868"
  },
  {
    "id": 193,
    "name": "+216"
  },
  {
    "id": 194,
    "name": "+90"
  },
  {
    "id": 195,
    "name": "+993"
  },
  {
    "id": 196,
    "name": "+1649"
  },
  {
    "id": 197,
    "name": "+688"
  },
  {
    "id": 198,
    "name": "+1"
  },
  {
    "id": 199,
    "name": "+44"
  },
  {
    "id": 200,
    "name": "+256"
  },
  {
    "id": 201,
    "name": "+380"
  },
  {
    "id": 202,
    "name": "+971"
  },
  {
    "id": 203,
    "name": "+598"
  },
  {
    "id": 204,
    "name": "+998"
  },
  {
    "id": 205,
    "name": "+678"
  },
  {
    "id": 206,
    "name": "+379"
  },
  {
    "id": 207,
    "name": "+58"
  },
  {
    "id": 208,
    "name": "+84"
  },
  {
    "id": 209,
    "name": "+681"
  },
  {
    "id": 210,
    "name": "+212"
  },
  {
    "id": 211,
    "name": "+967"
  },
  {
    "id": 212,
    "name": "+260"
  },
  {
    "id": 213,
    "name": "+263"
  }
]


// 已开通的手机区号代码
export default areaCode;
